import { render, staticRenderFns } from "./WeChatListCompleted.vue?vue&type=template&id=16de797b&scoped=true"
import script from "./WeChatListCompleted.vue?vue&type=script&lang=js"
export * from "./WeChatListCompleted.vue?vue&type=script&lang=js"
import style0 from "./WeChatListCompleted.vue?vue&type=style&index=0&id=16de797b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de797b",
  null
  
)

export default component.exports